module.exports = __webpack_public_path__ + "static/media/ehsan.6e05b38d.jpg";